const initVideoVolumeButton = () => {
  const quizVideo = document.querySelector(".graduates__video");

  if (!quizVideo) return;
  
  const quizVideoButton = quizVideo.querySelector(".graduates__video-mute");
  let currentMute = quizVideo.querySelector("video").muted;

  const onVideoAction = () => {
    quizVideoButton.style.opacity = "1";
    quizVideo.removeEventListener("mouseenter", onVideoAction);
    quizVideo.addEventListener("mouseleave", fromVideoAction);
  }

  const fromVideoAction = () => {
    quizVideoButton.style.opacity = "0";
    quizVideo.addEventListener("mouseenter", onVideoAction);
    quizVideo.removeEventListener("mouseenter", fromVideoAction);
  }

  quizVideoButton.addEventListener("click", () => {
    currentMute = !currentMute;
    quizVideo.querySelector("video").muted = currentMute;
    quizVideoButton.classList.toggle("graduates__video-mute--on");
  })


  quizVideo.addEventListener("mouseenter", onVideoAction);
  quizVideo.addEventListener("click", onVideoAction);
};

export default initVideoVolumeButton;
